import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { Page } from "types/dto/Page";
import { RegistroAcordoDTO } from "types/dto/RegistroAcordoDTO";
import { toast } from "react-hot-toast";
import { RequestFiltroContaReceberInadimplenciaDTO } from "types/request/RequestFiltroContaReceberInadimplenciaDTO";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";

export const useGetValorTotalReceitas = (request: RequestFiltroContaReceberInadimplenciaDTO) => {
  const { showModalSelecionarCobrancas } = useProcessosJudiciaisContext();

  const onError = () => {
    toast.error("Erro ao buscar valor total das receitas");
  };

  const config = {
    staleTime: 1000 * 60 * 10,
    retry: 5,
  };

  return useFetch<Page<RegistroAcordoDTO>>({
    key: [
      "valor-total-receitas-processo-judicial",
      request.unidadeId,
      request.dataVencimentoInicio,
      request.dataVencimentoFim,
    ],
    url: api.contaReceber.getValorTotalReceitas,
    params: request,
    enabled:
      request.unidadeId !== undefined &&
      request.dataVencimentoInicio != null &&
      request.dataVencimentoFim != null &&
      showModalSelecionarCobrancas,
    config,
    onError,
  });
};
